module.exports = __webpack_public_path__ + "static/media/chat-icon.68a0dc7f.png";